import { render, staticRenderFns } from "./PageExport.vue?vue&type=template&id=2c8f438e"
import script from "./PageExport.vue?vue&type=script&lang=js"
export * from "./PageExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports